const getNestedValue = (abilities, key) => {
  const levels = key.split('.');
  let current = abilities;

  for (const level of levels) {
    if (!Object.prototype.hasOwnProperty.call(current, level)) {
      return false;
    }
    current = current[level];
  }

  const checkValue = (value) => {
    if (typeof value === 'boolean' && value) {
      return true;
    } else if (typeof value === 'object') {
      return Object.values(value).some((v) => checkValue(v));
    }
    return false;
  };

  return checkValue(current);
};

export const checkNestedValue = (abilities, key) => {
  const keys = Array.isArray(key) ? key : [key];
  for (const key of keys) {
    if (getNestedValue(abilities, key)) {
      return true;
    }
  }

  return false;
};

export const hasNamespaceAccess = (abilities, namespace) => {
  if (!abilities || !namespace) return false;
  const namespaceAbilities = abilities[namespace];
  if (!namespaceAbilities) return false;

  return Object.values(namespaceAbilities).some((resource) => {
    if (typeof resource === 'object' && resource !== null) {
      return Object.values(resource).some((action) => {
        if (typeof action === 'boolean') {
          return action === true;
        }
        return action && action.enabled === true;
      });
    }
    return false;
  });
};

const matchesRole = (userRole: string, role: string) => {
  if (role.startsWith('!')) {
    return userRole !== role.slice(1);
  }
  return userRole === role;
};

export interface AccessRoute {
  checkname?: string | string[];
  role?: string | string[];
}

export const hasAccess = (route: AccessRoute, abilities: any, role: string) => {
  if (route.role) {
    const matches = Array.isArray(route.role) ? route.role.some(r => matchesRole(role, r)) : matchesRole(role, route.role);
    if (!matches) {
      return false;
    }
  }
  if (route.checkname) {
    return checkNestedValue(abilities, route.checkname);
  }

  return true;
};

